import { render, staticRenderFns } from "./KerbTopping.vue?vue&type=template&id=685ab664"
import script from "./KerbTopping.vue?vue&type=script&lang=js"
export * from "./KerbTopping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports